import { StyledCompProps } from "../../../../globalTypes/theme";
import styled from "../../../../config/emotion";

export const SecondaryColorLabel = styled.span<
  { marginLeft?: boolean } & StyledCompProps
>`
  color: ${({ theme }) => theme.colors.secondaryColor};
  ${({ marginLeft = false }) => marginLeft && "margin-left: 15px"};
`;
